import { render, staticRenderFns } from "./detailsCommon.vue?vue&type=template&id=2060f2b5&scoped=true"
import script from "./detailsCommon.vue?vue&type=script&lang=js"
export * from "./detailsCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060f2b5",
  null
  
)

export default component.exports